import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpUtils } from '../../common/http/http-utils';
import { ClientUtilities } from '../utils/client-utils';

@Injectable()
export class FleetQueryService {

    public isRunningInNGC: boolean = false;
    private apiBase: string;
    private fleetQueryAPI: string;

    constructor(public http: HttpClient) {
        this.isRunningInNGC = ClientUtilities.runningInPluginUI();
        const path = (window.location.pathname.match(/(.*)(\/hcx)(\/.*|$)/) || [])[1];
        this.apiBase = (!!path && !!this.isRunningInNGC) ? path + '/hcx-ui/rest' : '';
        this.fleetQueryAPI = this.apiBase + '/hybridity/api/service/hcx/list';
    }

    public getFleetAppliances(vcGuid: string) {
        let body:any = {};
        return this.http.post(HttpUtils.getBaseUrl() + this.fleetQueryAPI + '?vcGuid=' + vcGuid, body);
    }
}



// WEBPACK FOOTER //
// ./src/app/services/fleet-query.service.ts